// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__7iwvh","col":"styles_col__3XeGv"};